import CustomPrintPhoto from './CustomPrintPhoto';

export default CustomPrintPhoto;
